import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { RabbitCard } from "../components/RabbitCard";

export default function Rabbits() {
  const [rabbits, setRabbits] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = filter === "all" ? {} : { status: filter };
    api.get("/rabbits", { params })
      .then((r) => setRabbits(r.data))
      .finally(() => setLoading(false));
  }, [filter]);

  const filters = [
    { k: "all", l: "All" },
    { k: "available", l: "Available" },
    { k: "reserved", l: "Reserved" },
    { k: "sold", l: "Sold" },
  ];

  return (
    <div className="grain-bg" data-testid="page-rabbits">
      <section className="border-b border-border bg-cream">
        <div className="mx-auto max-w-7xl px-6 py-20 lg:px-12 lg:py-28">
          <div className="section-label">Our herd</div>
          <h1 className="mt-4 font-serif text-5xl tracking-tight sm:text-6xl">Available Lion's Mane rabbits</h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-stone">
            Each rabbit listed below is part of our current season's herd. All are pedigreed, health-checked, and raised in our home. Click any rabbit to view details or reserve.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            {filters.map((f) => (
              <button
                key={f.k}
                onClick={() => setFilter(f.k)}
                data-testid={`filter-${f.k}`}
                className={`px-5 py-2 text-xs uppercase tracking-[0.2em] transition ${
                  filter === f.k
                    ? "bg-bark text-cream"
                    : "border border-border bg-white text-foreground hover:border-bark"
                }`}
              >
                {f.l}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 py-20 lg:px-12">
        {(() => {
          if (loading) return <div className="py-24 text-center text-stone">Loading…</div>;
          if (rabbits.length === 0) return <div className="border border-border bg-white p-16 text-center text-stone">No rabbits in this category yet.</div>;
          return (
            <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
              {rabbits.map((r, i) => <RabbitCard key={r.id} rabbit={r} idx={i} />)}
            </div>
          );
        })()}
      </section>
    </div>
  );
}
